<div class="options" (click)="picker.open()">
  <div class="d-flex flex-column">
    <div class="label">
      <ng-container i18n="The label on the calendar field where the user picks the dates for a hotel booking"
        >Dates</ng-container
      >
    </div>

    <mat-form-field floatLabel="never">
      <mat-label>
        <ng-container
          i18n="The label on the calendar field where the user is told to pick the dates for a hotel booking"
          >Select your dates</ng-container
        >
      </mat-label>

      <mat-date-range-input [rangePicker]="picker" [formGroup]="formGroup" [dateFilter]="dateFilter">
        <input matStartDate formControlName="start" readonly />
        <input matEndDate formControlName="end" readonly />
      </mat-date-range-input>

      <mat-error *ngIf="formGroup.hasError('unavailableDates')">
        <ng-container i18n="Calendar validation error">Some of the selected dates are unavailable:</ng-container>
        {{ formGroup.errors.unavailableDates }}
      </mat-error>

      <mat-error *ngIf="formGroup.hasError('periodLength')">
        <ng-container i18n="Calendar validation error">Please select more than one day</ng-container>
      </mat-error>

      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <i class="fas fa-calendar-alt calendar-icon ml-3"></i>
</div>
